
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherItemDetailsGrid extends Serenity.EntityGrid<GiftVoucherItemDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherItemDetails'; }
        protected getDialogType() { return GiftVoucherItemDetailsDialog; }
        protected getIdProperty() { return GiftVoucherItemDetailsRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherItemDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherItemDetailsRow.localTextPrefix; }
        protected getService() { return GiftVoucherItemDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}